import { gql } from "gql";

export const GET_COMPANY_DOCUMENT_BY_ID = gql(/* GraphQL */ `
  query GetCompanyDocumentById($id: ID!) {
    getCompanyDocumentById(id: $id) {
      id
      name {
        ...LocalizedValueDtoFragment
      }
      description {
        ...LocalizedValueDtoFragment
      }
      isAssignToNewPersons

      ...CompanyDocumentIsActive
      ...CompanyDocumentReadConfirmationType

      confirmationInfoCount {
        total
      }
      folder {
        ... on CompanyDocumentFolderDto {
          id
        }
        ... on Hidden {
          ...Hidden
        }
      }
      file {
        id
      }
    }
  }
`);
